<template>
  <div class="login-bg">
    <div class="login-container">
      <div class="system-logo">
        <div class="logo-icon">
          <i class="el-icon-cloudy"></i>
        </div>
        <h1 class="system-title">4KHD 网盘资源管理系统</h1>
      </div>
      <el-card class="login-card tech-card">
        <div class="login-header">
          <h2 class="login-title tech-title">用户登录</h2>
          <el-button type="text" class="register-link" @click="$router.push('/register')">注册新账号</el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="loginForm" label-width="80px" @keyup.enter.native="onLogin" class="tech-form">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form.username" autocomplete="username" prefix-icon="el-icon-user" class="tech-input" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="form.password" type="password" autocomplete="current-password" prefix-icon="el-icon-lock" class="tech-input" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="onLogin" class="login-btn tech-btn">登录</el-button>
          </el-form-item>
          <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" style="margin-bottom:0" />
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    onLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        this.error = '';
        try {
          const res = await this.$axios.post('/user/login', this.form);
          if (res && res.code === 200) {
            // 清除API Key缓存，强制用户重新获取
            localStorage.removeItem('api_key');
            localStorage.setItem('token', res.token);
            this.$message.success('登录成功');
            // 跳转到redirect参数指定的页面或首页
            const redirect = this.$route.query.redirect || '/';
            this.$router.replace(redirect);
            window.location.reload();
            // 调试用：控制台打印 token
            console.log('登录成功，token:', res.token);
          } else {
            this.error = res.message || '登录失败';
            this.form.password = '';
          }
        } catch (e) {
          this.error = e.response?.data?.message || '网络错误';
          this.form.password = '';
        } finally {
          this.loading = false;
        }
      });
    }
  }
}
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  background: #22313a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.system-logo {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  font-size: 3rem;
  color: #409EFF;
  margin-bottom: 16px;
}

.system-title {
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin: 0 0 8px 0;
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}

.login-card {
  width: 360px;
  padding: 32px 24px 20px 24px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
}

.login-card:hover {
  box-shadow: 0 4px 18px rgba(0,0,0,0.10);
  transform: none;
}

.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.login-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #222;
  letter-spacing: 1px;
  margin: 0;
}

.register-link {
  color: #409EFF;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  transition: color 0.2s;
}

.register-link:hover {
  color: #66b1ff;
  text-shadow: none;
}

.tech-form .el-form-item__label {
  color: #333;
  font-weight: 500;
}

.login-btn {
  width: 100%;
  font-size: 16px;
  letter-spacing: 1px;
  border-radius: 6px;
  background: #409EFF;
  border: none;
  height: 42px;
  font-weight: 600;
  color: #fff;
  transition: background 0.2s;
}

.login-btn:hover {
  background: #66b1ff;
  box-shadow: none;
  transform: none;
}

.tech-title {
  background: none !important;
  -webkit-background-clip: initial !important;
  -webkit-text-fill-color: initial !important;
  background-clip: initial !important;
  color: #222 !important;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
}

@media (max-width: 768px) {
  .system-title {
    font-size: 1.3rem;
  }
  .login-card {
    width: 95%;
    max-width: 340px;
    padding: 20px 8px 12px 8px;
  }
  .logo-icon {
    font-size: 2.2rem;
  }
}
</style> 